import fs from 'node:fs';
import path from 'node:path';

import { packageRoot } from './package-root.ts';

/**
 * Whether the CLI is running from the platform monorepo (dev checkout)
 * vs a globally-installed npm package.
 *
 * Published builds contain a `.published` sentinel file stamped by CI.
 * Its absence means we're running from source.
 */
export const isLocalDev = !fs.existsSync(path.join(packageRoot, '.published'));
